import React from 'react';
import {View, Panel, PanelHeader, Group, List, SimpleCell, FormItem, RadioGroup, Radio, Spinner} from '@vkontakte/vkui';
import {instanceOf} from 'prop-types';
import {Button, FormLayout, Div, Input} from '@vkontakte/vkui';
import {
    Icon20Info,
    Icon28FolderOutline,
    Icon28ShoppingCartOutline,
    Icon16Phone,
    Icon16MailOutline,
    Icon28Video, Icon24SquareGrid3x3, Icon24List, Icon24VideoFillNone
} from "@vkontakte/icons";
import {withCookies, Cookies} from 'react-cookie';
import {AdaptivityContext} from "./assets/constants";
import CartApi from "./api/CartApi";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import axios from "axios";
import moment from "moment";
import ClubManagerCard from "./assets/ClubsManagerCard";


class Clubs extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        const day = new Date().getDate()
        let daysLeft = 0

        if (day < 25) {
            daysLeft = 25 - day
        }
        this.state = {
            name: cookies.get('reactcatalog') || '0',
            daysLeft: daysLeft,
            bonus_text: '',
            loading: false
        };

    }

    getStats = () => {
        let now = new Date()
        this.setState({bonus_text: '', loading: true})
        let startDate = moment([now.getFullYear(), now.getMonth()]);

        // Clone the value before .endOf()
        let endDate = moment(startDate).endOf('month');

        // just for demonstration:
        console.log(startDate.toDate());
        console.log(endDate.toDate());

        let body = new FormData()
        //body.append('page', 1)
        body.append('start', moment(startDate).format('DD.MM.YYYY'))
        body.append('end', moment(endDate).format('DD.MM.YYYY'))
        //body.append('epp', 100000)
        body.append(this.props.current_club.code, 1)
        body.append('show_sub_docs', 1)

        axios.post(this.props.base_url + '?app=saledocs&act=getMeters', body,
            {
                withCredentials: true

            }
        ).then((response) => {

            if (this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') {
                this.setState({
                    loading: false,
                    bonus_text:
                        <div>{`Начислено всего за ваши заказы: ${(response.data.meters * 80).toFixed(2)} руб. за ${response.data.meters}м2.`}
                            <br/>
                            {`Подтверждено: ${(response.data.metersConfirm * 80).toFixed(2)} руб. за ${response.data.metersConfirm}м2.`}
                        </div>
                })

            } else {
                this.setState({
                    loading: false,
                    bonus_text: 'Начислено всего за ваши заказы: ' + (response.data.meters * 80).toFixed(2) + ' руб. за ' + response.data.meters + 'м2'
                })
            }
        })

    }

    componentDidMount() {
        this.getStats()
    }

    changeClub = club => {
        this.setState({bonus_text: '', loading: true})
        this.props.changeClub(club)

        setTimeout(() => this.getStats(), 700)
    }

    render() {

        let managers_club = null

        switch (this.props.current_club.code) {
            case 'is_firm_fit':
                managers_club = this.props.current_user.manager_fft;
                break;
            case 'is_primavera':
                managers_club = this.props.current_user.manager_primavera;
                break;
            case 'is_betta_':
                managers_club = this.props.current_user.manager_betta_;
                break;
            case 'is_lq':
                managers_club = this.props.current_user.manager_lq;
                break;
        }
        return (this.props.current_user != undefined &&
            <Group className="main-element" style={{padding: AdaptivityContext.isMobile ? "14px" : 'inherit'}}>
                <Div>
                    <FormItem style={{maxWidth: '650px'}}>
                        <RadioGroup mode="horizontal">
                            {this.props.clubs.map(club =>
                                <Radio name="current_club" value={club.code} size={24}
                                       checked={club.code === this.props.current_club.code}
                                       onChange={() => this.changeClub(club)}>
                                    {club.name}
                                </Radio>)}
                        </RadioGroup>
                    </FormItem>
                    <h1>Добро пожаловать
                        в {this.props.current_club.name}, {this.props.current_user != undefined ? this.props.current_user.name : ''}!</h1>
                    {(this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') &&
                        <h4>Напишите если бонусы не получили: <a
                            href="mailto:service@mbc-logistics.ru">service@mbc-logistics.ru</a></h4>}
                    {this.props.current_club.code !== 'is_primavera' &&
                        <SimpleCell key="cmdBonuses" before={this.state.loading ? <Spinner/> : <Icon20Info/>}
                                    mode="more"
                                    multiline>
                            {this.state.loading ? 'Запрашиваем данные с сервера' : this.state.bonus_text}
                        </SimpleCell>}
                    <div key="goCatalog"
                         className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                        <div className="main-page-button" href="#" data-story="ostatki_clubs_story" data-FFCMode="1"
                             onClick={(event) => {
                                 event.preventDefault();
                                 this.props.changeStory(event)
                             }}>
                            <Icon28FolderOutline width={60} height={60}/>
                            <p className={"main-page-button_text " + this.props.current_club.code}>Товары <br/> {this.props.current_club.name}
                            </p>
                        </div>
                        <div key="goReport" className="main-page-button orange" href="#"
                             data-story="report_ffc_story" onClick={(event) => {
                            event.preventDefault();
                            this.props.changeStory(event)
                        }}>
                            <Icon28FolderOutline width={60} height={60}/>
                            <p className="main-page-button_text" style={{fontSize: '16px'}}>Отчет</p>
                            <div className="main-page-button_cart-counter">?</div>
                        </div>
                        <div key="goCart" className="main-page-button orange" href="#" data-story="cart_story"
                             onClick={(event) => {
                                 event.preventDefault();
                                 this.props.changeStory(event)
                             }}>
                            <Icon28ShoppingCartOutline width={60} height={60}/>
                            <p className="main-page-button_text">Корзина</p>
                            <div className="main-page-button_cart-counter">{CartApi.items.length}</div>
                        </div>

                        {this.props.current_user['meta']['settings']['firm_fit_club']
                        && this.props.current_user['default_klient']
                        && this.props.current_user['default_klient']['meta']
                        && this.props.current_user['default_klient']['meta']['Менеджер']
                        && this.props.current_user['default_klient']['meta']['Менеджер']['ФИО'] ?
                            <div key="managerInfo" className="main-page_manage-info ">
                                <div className="manage-info-flex">
                                    <p className="my-manage">Ваш менеджер</p>
                                    <p className="name-manage">{this.props.current_user['default_klient']['meta']['Менеджер']['ФИО'] ? this.props.current_user['default_klient']['meta']['Менеджер']['ФИО'] : 'Не задано в 1С'}</p>
                                    <p className="tel-manage">
                                        <a href={"tel:+7" + this.props.current_user['default_klient']['meta']['Менеджер']['Телефон'].toString().replace('-', '').replace(' ', '')}>
                                            {this.props.current_user['default_klient']['meta']['Менеджер']['Телефон'] ? "+7 " + this.props.current_user['default_klient']['meta']['Менеджер']['Телефон'] : 'Не задано в 1С'}</a>
                                    </p>
                                    <p className="email-manage"><a target="_blank"
                                                                   href={"mailto:" + this.props.current_user['default_klient']['meta']['Менеджер']['email']}><i
                                        className="fa fa-envelope"></i>&nbsp;{this.props.current_user['default_klient']['meta']['Менеджер']['email'] ? this.props.current_user['default_klient']['meta']['Менеджер']['email'] : 'Не задано в 1С'}
                                    </a>
                                    </p>

                                </div>
                            </div> : ''}
                        {managers_club && Array.isArray(managers_club) ? managers_club.map((manager_club) => {

                            return <ClubManagerCard
                                current_club={this.props.current_club}
                                manager_club={manager_club}
                            />
                        }) : ''}
                    </div>
                </Div>
            </Group>
        )
    }

}

export default withCookies(Clubs);
